import { ClarityType } from '../clarityValue.esm.js';

var noneCV = function noneCV() {
  return {
    type: ClarityType.OptionalNone
  };
};

var someCV = function someCV(value) {
  return {
    type: ClarityType.OptionalSome,
    value: value
  };
};

export { noneCV, someCV };
//# sourceMappingURL=optionalCV.esm.js.map
